<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.epmallcart_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {getList, getDetail, add, update, remove,getPage} from "@/api/epmall/cart";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height:'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          addBtn:false,
          viewBtn: true,
          delBtn:false,
          editBtn:true, // 行内编辑按钮
          selection: true,
          dialogClickModal: false,
          column: [
            {
            label: "商家",
            prop: "storeName",
            addDisplay: false,
            editDisplay: false,
            rules: [
              {
                required: false,
                message: "请输入楼宇",
                trigger: "blur",
              },
            ],
          },
            {
              label: "菜品",
              prop: "itemTitle",
              editDisplay:false,
              width:240,
              rules: [{
                required: true,
                message: "请输入菜品",
                trigger: "blur"
              }]
            },
            {
              disabled: true,
              label: "菜品价格",
              prop: "itemPrice",
              rules: [{
                required: true,
                message: "请输入菜品价格",
                trigger: "blur"
              }]
            },
            {
              label: "菜品数量",
              prop: "itemNum",
              rules: [{
                required: true,
                message: "请输入菜品数量",
                trigger: "blur"
              }]
            },
            {
              label: "加入时间",
              prop: "cartTime",
              type: "datetime",
              editDisplay:false,
              format: "yyyy-MM-dd hh:mm",
              valueFormat: "yyyy-MM-dd hh:mm",
              rules: [{
                required: true,
                message: "请输入加入时间",
                trigger: "blur"
              }]
            },
            {
              label: "用户",
              prop: "userName",
              editDisplay:false,
              rules: [{
                required: true,
                message: "请输入用户ID",
                trigger: "blur"
              }]
            },
             {
            label: "商家",
            prop: "storeId",
            hide: true,
            search: true,
            searchSpan: 8,
            addDisplay: true,
            editDisplay: false,
            viewDisplay: false,
            type: "select",
            dicUrl:
              "/api/park-epmall/store/list?current=1&size=10000000&",
            props: {
              label: "name",
              value: "id",
            },
            dicFormatter: (res) => {
                let ds =  res.data.records;
                ds.forEach(e=>{
                  e.id = Number(e.id);
                });
                return ds;
            },
            rules: [
              {
                required: false,
                message: "请输入楼宇Id",
                trigger: "blur",
              },
            ],
          },

          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.epmallcart_add, false),
          viewBtn: this.vaildData(this.permission.epmallcart_view, false),
          delBtn: this.vaildData(this.permission.epmallcart_delete, false),
          editBtn: this.vaildData(this.permission.epmallcart_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          window.console.log(error);
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(this.ids);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail(this.form.id).then(res => {
            this.form = res.data.data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage){
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize){
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        this.loading = true;
        getPage(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
